import React, { useEffect, Dispatch, SetStateAction, useState } from "react";
import { ThemeProvider, createTheme } from '@mui/material';
import MaterialTable from 'material-table'
import { useModal } from 'react-hooks-use-modal';
import { useAuth } from "../hooks/use-auth";
import axios from 'axios';
import { Search } from "@mui/icons-material";
import { IconWrapper, ModalStyle, ModalClose, DivMargin } from "styles/styles";

interface Props {
	search: string;
	setSelectedContents: any;
	setSelectedBranchContents: any;
}


interface ParentProps {
	data: ParentDataProps[];
	setParentRowData: any;
	setSelectedId: Dispatch<SetStateAction<number>>;
	search: string;
}

interface ChildProps {
	data: ChildDataProps[];
	setSelectedBranchContents: any;
	parentRowData: ParentDataProps[];
	setSelectedContents: any;
	close: any;
	search: string;
}

interface ParentDataProps {
	[key: string]: string | number;
}

interface ChildDataProps {
	[key: string]: string | number;
}

const Parent = ({ data, setSelectedId, setParentRowData, search }: ParentProps) => {
	let parentArray: any = [];
	if (search === "customers") {
		parentArray = [{ title: '', field: 'customer_id' },
		{ title: '得意先共有ID', field: 'share_code' },
		{ title: '得意先ID', field: 'display_id' },
		{ title: '得意先', field: 'name' },
		{ title: '略称', field: 'abbreviation' },
		]
	} else if (search === "product-numbers") {
		parentArray = [{ title: '', field: 'product_number_id' },
		{ title: '品番', field: 'display_id' },
		{ title: 'メモ', field: 'memo' }]
	}
	let PAGE_TITLE: string;
	switch (search) {
		case "customers":
			PAGE_TITLE = "得意先";
			break;
		case "product-numbers":
			PAGE_TITLE = "品番";
			break;
		default:
			PAGE_TITLE = "キーワードが見つかりません";
	}

	//arrayの生成
	const defaultObj: any = {};
	for (const element of parentArray) {
		defaultObj[element.field] = element.default;
	}
	const columnsArray: any = [];
	for (const element of parentArray) {
		if (element.title) {
			columnsArray.push({
				title: element.title,
				field: element.field,
				cellStyle: {
					minWidth: 150,
					maxWidth: 150,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis'
				}
			})
		}
	}
	//カラムなど生成ここまで

	const [pageSize, setPageSize] = React.useState(5);
	const defaultMaterialTheme = createTheme();
	const [selectedRow, setSelectedRow] = useState(null);

	return (
		<>
			<ThemeProvider theme={defaultMaterialTheme}>
				<MaterialTable
					title={PAGE_TITLE}
					columns={columnsArray}
					data={data}
					options={{
						paging: false,
						actionsColumnIndex: -1,
						headerStyle: { whiteSpace: 'nowrap' },
						rowStyle: (rowData) => ({
							overflowWrap: 'break-word',
							backgroundColor: selectedRow === rowData.tableData.id ? '#EEE' : '#FFF',
						})
					}}
					onChangeRowsPerPage={(pageSize) => {
						setPageSize(pageSize);
					}}
					onRowClick={(event: any, rowData: any) => {
						event.preventDefault();
						setParentRowData(rowData);
						if (search === "customers") {
							setSelectedId(rowData.customer_id);
						} else if (search === "product-numbers") {
							setSelectedId(rowData.product_number_id);
						}
						setSelectedRow(rowData.tableData.id);
					}}
				/>
			</ThemeProvider>
		</>
	)
}


const Child = ({ data, setSelectedBranchContents, parentRowData, setSelectedContents, close, search }: ChildProps) => {
	let parentArray: any = [];
	let PAGE_TITLE = "";
	if (search === "customers") {
		//arrayの生成
		parentArray = [{ title: '', field: 'customer_id' },
		{ title: '', field: 'customer_branch_id' },
		{ title: '枝番', field: 'display_id' },
		{ title: '部門名', field: 'department_name' },
		{ title: '担当者名', field: 'name' },
		]
		PAGE_TITLE = "得意先枝番"
	} else if (search === "product-numbers") {
		parentArray = [{ title: '', field: 'product_number_id' },
		{ title: '', field: 'product_number_branch_id' },
		{ title: '枝番', field: 'display_id' },
		{ title: '得意先ID', field: 'customer_display_id' },
		{ title: '得意先枝番', field: 'customer_branch_display_id' },
		{ title: '品名', field: 'name' },
		{ title: 'メモ', field: 'memo' },
		{ title: '', field: 'standard_processes_id' },
		{ title: '', field: 'standard_processes_display_id' },
		]
		PAGE_TITLE = "品番枝番"
	}
	const defaultObj: any = {};
	for (const element of parentArray) {
		defaultObj[element.field] = element.default;
	}
	const columnsArray: any = [];
	for (const element of parentArray) {
		if (element.title) {
			columnsArray.push({
				title: element.title,
				field: element.field,
				cellStyle: {
					minWidth: 150,
					maxWidth: 150,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis'
				}
			})
		}
	}

	//カラムなど生成ここまで

	const [pageSize, setPageSize] = React.useState(5);
	const defaultMaterialTheme = createTheme();

	return (
		<>
			<ThemeProvider theme={defaultMaterialTheme}>
				<MaterialTable
					title={PAGE_TITLE}
					columns={columnsArray}
					data={data}
					options={{
						paging: false,
						actionsColumnIndex: -1,
						headerStyle: { whiteSpace: 'nowrap' },
						rowStyle: { overflowWrap: 'break-word' }
					}}
					onChangeRowsPerPage={(pageSize) => {
						setPageSize(pageSize);
					}}
					onRowClick={(event: any, rowData: any) => {
						event.preventDefault();
						setSelectedContents(parentRowData);
						setSelectedBranchContents(rowData);
						close();
					}}
				/>
			</ThemeProvider>
		</>
	)
}


const IdSearchButtonWithParent = ({ search, setSelectedContents, setSelectedBranchContents }: Props) => {
	//modal
	const [modalTitle, setModalTitle] = React.useState('');
	const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
	//modal end

	const auth = useAuth();

	const [parentData, setParentData] = useState<ParentDataProps[]>([]);
	const [parentRowData, setParentRowData] = useState<ParentDataProps[]>([]);
	const [childData, setChildData] = useState<ChildDataProps[]>([]);
	const [selectedId, setSelectedId] = useState<number>(0);


	const condition = () => {
		return (
			search === "customers" || search === "product-numbers"
		);
	}
	useEffect(() => {
		if (condition()) {
			try {
				axios.get(`/v0/factories/${auth.factoryId}/${search}`, {
					headers: auth.authorizationHeader,
				}).then((res: any) => {
					if (res.data.length) {
						setParentData(res.data);
					} else {
						setParentData([]);
					}
				})
			} catch (err) {
				console.log(err)
			}
		}
	}, [auth]);

	let branchName: string;

	if (search === "customers") {
		branchName = "customer-branches";
	} else if (search === "product-numbers") {
		branchName = "product-number-branches";
	}
	useEffect(() => {
		if (condition()) {
			if (selectedId === 0) {
				setChildData([]);
			} else {
				try {
					if (branchName) {
						axios.get(`/v0/${search}/${selectedId}/branches`, {
							headers: auth.authorizationHeader,
							params: {
								factory_id: auth.factoryId
							}
						}).then((res: any) => {
							if (res.data.length) {
								setChildData(res.data)
							} else {
								setChildData([]);
							}
						})
					}
				} catch (err) {
					console.log(err)
				}
			}
		}
	}, [auth, selectedId])

	if (condition()) {
		return (
			<>
				<IconWrapper><Search style={iconStyle} onClick={open} /></IconWrapper>
				<Modal>
					<ModalStyle>
						<Parent data={parentData} setParentRowData={setParentRowData} setSelectedId={setSelectedId} search={search} />
						<DivMargin></DivMargin>
						<Child data={childData} setSelectedBranchContents={setSelectedBranchContents} parentRowData={parentRowData} setSelectedContents={setSelectedContents} close={close} search={search} />
						<ModalClose onClick={close}>CLOSE</ModalClose>
					</ModalStyle>
				</Modal>
			</>
		)
	} else {
		return (<></>)
	}
}

export default IdSearchButtonWithParent;

const iconStyle = {
	color: 'white',
	fontSize: ' 22px',
	fontWeight: '700',
	backgroundColor: '#1A4EA1',
	borderRadius: '5px'
}
